import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { IconButton } from "@material-ui/core";
import { DateRange } from "@material-ui/icons";
import { DateRangePickerDialog } from "./DateRangePickerDialog";
import { PlanSelector } from "./PlanSelector";

/**
 * Controls component for subscription tables (date range picker + plan selector)
 */
export const SubscriptionTableControls = ({
  selectionRange,
  onRangeChange,
  openDialog,
  onOpenDialog,
  selectedPlan,
  onPlanChange,
}) => {
  return (
    <>
      <div
        style={{
          textAlign: "right",
          marginBottom: "-65px",
          zIndex: "999",
          paddingRight: "20px",
          position: "relative",
          marginRight: "50px",
          paddingTop: "20px",
        }}
      >
        From {moment(selectionRange.startDate).format("MM/DD/YYYY")} to{" "}
        {moment(selectionRange.endDate).format("MM/DD/YYYY")}
        <IconButton onClick={() => onOpenDialog(true)}>
          <DateRange />
        </IconButton>
        &nbsp; Plans:&nbsp;
        <PlanSelector value={selectedPlan} onChange={onPlanChange} />
        &nbsp;&nbsp;&nbsp;
      </div>
      <DateRangePickerDialog
        open={openDialog}
        onClose={() => onOpenDialog(false)}
        selectionRange={selectionRange}
        onChange={onRangeChange}
      />
    </>
  );
};

SubscriptionTableControls.propTypes = {
  selectionRange: PropTypes.object.isRequired,
  onRangeChange: PropTypes.func.isRequired,
  openDialog: PropTypes.bool.isRequired,
  onOpenDialog: PropTypes.func.isRequired,
  selectedPlan: PropTypes.string.isRequired,
  onPlanChange: PropTypes.func.isRequired,
};

